import { FC, PropsWithChildren, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { useLockBodyScroll } from "../../hooks/useBlockScroll";
import { useOutsideClick } from "../../hooks/useOutsideClick";

const StyledModal = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;

  background-color: #000000dd;
  top: 0;
  left: 0;
`;

const StyledModalContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const StyledModalCloseButton = styled.button`
  background: none;
  position: absolute;
  top: 10px;
  right: 10px;
  color: #fff;
`;

const StyledContent = styled.div`
  padding-top: 150px;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media (max-width: 1024px) {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 150px;
    left: 0;
    transform: unset;
    padding-top: 0;

  }
`

function createWrapperAndAppendToBody(wrapperId: string) {
  const wrapperElement = document.createElement("div");
  wrapperElement.setAttribute("id", wrapperId);
  wrapperElement.style.width = "100vw";

  document.body.appendChild(wrapperElement);
  return wrapperElement;
}

export interface IModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const Modal: FC<PropsWithChildren<IModalProps>> = (props) => {
  const { children, isOpen, onClose } = props;
  const portalRef = useRef(null);
  useLockBodyScroll(true);

  useOutsideClick(portalRef, onClose);

  useEffect(() => {
    const closeHandler = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return;
      onClose();
    };

    window.addEventListener("keydown", closeHandler);

    return () => {
      window.removeEventListener("keypress", closeHandler);
    };
  }, [onClose]);

  if (!isOpen) return null;

  let element = document.getElementById("portals");
  // if element is not found with wrapperId,
  // create and append to body
  if (!element) {
    element = createWrapperAndAppendToBody("portals");
  }
  return createPortal(
    <StyledModal>
      <StyledModalContainer>
        <StyledModalCloseButton onClick={onClose}>X</StyledModalCloseButton>
        <StyledContent ref={portalRef}>
          {children}
        </StyledContent>
      </StyledModalContainer>
    </StyledModal>,
    element
  );
};
